module.exports = __webpack_public_path__ + "img/banner-text-en@3x.66b767c5.png";